import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-preview-car',
  templateUrl: './preview-car.component.html',
  styleUrls: ['./preview-car.component.scss']
})
export class PreviewCarComponent implements OnInit {

  @Input() car = {
    portaDianteiraDireita: {status: 0},
    portaDianteiraEsquerda: {status: 0},
    portaTraseiraDireita: {status: 0},
    portaTraseiraEsquerda: {status: 0},
    lateralTraseiraDireita: {status: 0},
    lateralTraseiraEsquerda: {status: 0},
    paraLamaEsquerda: {status: 0},
    paraLamaDireita: {status: 0},
    capo: {status: 0},
    teto: {status: 0},
    tampaPortaMalas: {status: 0},
    paraChoqueDianteira: {status: 0},
    paraChoqueTraseira: {status: 0},
  }

  @Input() erro = {
    esquerda: 0,
    direita: 0,
    frente: 0,
    traseira: 0
  }

  constructor() { }

  ngOnInit() {
  }

}
